import QuestionViewVerbal from "./QuestionViewVerbal";

export default class QuestionViewComparison extends QuestionViewVerbal {
    constructor(question) {
        super(question);
    }

    filterTemplate(x) {
        return x.lowest === this._question.lowest;
    }
}